import { Pipe, PipeTransform } from '@angular/core';
import { DateTime } from 'luxon';

@Pipe({
    name: 'timeSince',
    pure: false,
    standalone: false
})
export class TimeSincePipe implements PipeTransform {
    transform(value: DateTime | null): string | null {
        return value?.toRelative();
    }
}